import React from 'react';
import { FormatterProps } from 'react-data-grid';
import isFunction from 'lodash/isFunction';
import { ListSubheader } from '../ListSubheader';
import { BodyRow, HeaderRow, RowType } from '../types';
import { ContextMenuButton } from '../ContextMenuButton';
import { ContextMenuProps } from '../ContextMenu/types';
import { ListItem } from '../ListItem';

interface ColumnFormatterProps {
  onCollapse: (rowId: string) => void;
  isSectionCollapsed?: boolean;
  listItemClassName?: string;
  contextMenuProps: ContextMenuProps;
}

export const ColumnFormatter: React.FC<
  ColumnFormatterProps & FormatterProps<BodyRow>
> = ({
  row,
  column,
  onCollapse,
  isSectionCollapsed,
  listItemClassName,
  contextMenuProps,
}) => {
  if (row.type === RowType.SUBHEADER) {
    const collapsible = row.collapsible ?? true;
    return (
      <ListSubheader
        onClick={() => {
          if (collapsible) {
            onCollapse(row.id as string);
          }
        }}
      >
        {isFunction(row.content)
          ? row.content({ isSectionCollapsed })
          : row.content}
      </ListSubheader>
    );
  }

  if (row.type === RowType.CUSTOM_CONTENT) {
    return <>{row.content}</>;
  }

  if (((column as unknown) as HeaderRow)?.contextMenu) {
    if (row[column.key]) {
      return <>{row[column.key]}</>;
    }
    return !row.loading ? (
      <ContextMenuButton row={row} contextMenuProps={contextMenuProps} />
    ) : null;
  }

  return (
    <ListItem
      className={listItemClassName}
      justifyContent={
        ((column as unknown) as HeaderRow)?.centered ? 'center' : 'flex-start'
      }
    >
      <>{row[column.key]}</>
    </ListItem>
  );
};
